import { z } from "zod";

export const editMessageThreadSchema = () =>
  z.object({
    content: z.string(),
  });
export type EditMessageThreadFormValues = z.infer<ReturnType<typeof editMessageThreadSchema>>;
